import { render } from "./BannerIT.vue?vue&type=template&id=fc587070&scoped=true"
import script from "./BannerIT.vue?vue&type=script&lang=js"
export * from "./BannerIT.vue?vue&type=script&lang=js"

import "./BannerIT.vue?vue&type=style&index=0&id=fc587070&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc587070"]])

export default __exports__